import { useEffect, useRef, useState } from 'react';
import { useIsMobile } from '@/hooks/useIsMobile';

const DEFAULT_WIDTH_PX = 340;

interface Options {
  maxWidth: number;
  minWidth?: number;
  reservedPx?: number;
}

export const useResponsiveTabsWidth = ({
  maxWidth,
  minWidth = DEFAULT_WIDTH_PX,
  reservedPx = DEFAULT_WIDTH_PX,
}: Options) => {
  const isMobile = useIsMobile();
  const ref = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(maxWidth);

  useEffect(() => {
    if (isMobile) {
      return;
    }

    const update = () => {
      const left = ref.current?.getBoundingClientRect().left ?? 0;
      const available = window.innerWidth - left - reservedPx;
      setWidth(Math.max(minWidth, Math.min(maxWidth, available)));
    };

    update();
    window.addEventListener('resize', update);

    return () => window.removeEventListener('resize', update);
  }, [isMobile, minWidth, maxWidth, reservedPx]);

  return {
    ref,
    style: isMobile ? undefined : { width },
  };
};
